import { create } from "zustand";

//* Define store using zustand for trigger reset button
export const useResetStore = create((set) => ({
  formReset: false,
  setFormReset: (value) => set({ formReset: value }),
}));

//* Define store for node drop. 
export const useDroppedNodeStore = create((set) => ({
  droppedNodes: [],
  setDroppedNodes: (values) => set({ droppedNodes: [...new Set(values)] }),
}))

//* Define store for the duplicate game number
export const useDuplicateGameStore = create((set) => ({
  duplicateGames: {},
  setDuplicateGames: (values) => set({ duplicateGames: values }),
}));

//* Define team data label store
export const useTeamDataStore = create((set) => ({
  teamData: [],
  setTeamData: (values) => set({ teamData: values })
}));

//** Game number store
export const useGameNumberStore = create((set) => ({
  gameNumbers: [],
  setGameNumbers: (values) => set({ gameNumbers: values })
}))
